<!--字段配置Ec-->
<template>
  <div class="field-setting">
    <div class="step">
      <h6>第一步：选择资源分发类型</h6>
      <el-form label-width="520px" label-position="left">
        <el-form-item label="资源分发类型" prop="param1">
          <el-select placeholder="请选择接收小组" v-model="form.type">
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="step">
      <h6>第二步：配置资源分发参数</h6>
      <div v-show="form.type === 1">
        <div class="field-menu">
          <span>资源区域</span>
          <span><font style="color:red">*</font>接收小组</span>
        </div>
        <el-form label-width="380px" label-position="left" :model="formFiled">
          <div class="list" v-for="(data, dataIndex) in form.areaRuleList" :key="dataIndex">
            <div class="list-L">
              <ul>
                <li v-for="(item,itemIndex) in area" :key="itemIndex">
                  <span class="area">【{{item}}】</span>
                  <template v-for="(province, provinceIndex) in province[itemIndex]">
                    <span v-if="data.provinceList.indexOf(province.name) === -1 && province.disable" class="no">{{province.name}}</span>
                    <span v-else :class="{ active: data.provinceList.indexOf(province.name) !== -1}" @click="choItem(dataIndex, province.name)">{{province.name}}</span>
                  </template>
                </li>
              </ul>
            </div>
            <div class="list-R">
              <el-select v-model="data.acceptGroupId" clearable placeholder="请选择接收小组">
                <el-option v-for="(item,index) in groupList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <span class="remove" @click="removeRow(dataIndex)">删除</span>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div v-show="form.type === 2">
      <div class="field-menu">
        <span>渠道类型</span>
        <span><font style="color:red">*</font>接收小组</span>
      </div>
      <el-form label-width="360px" label-position="left" :model="formFiled">
        <div class="list" v-for="(data, dataIndex) in form.channelTypeRuleList" :key="dataIndex">
          <div class="list-L">
            <el-select v-model="data.channelType" clearable placeholder="请选择接收小组" style="padding-left:25px;">
              <el-option v-for="(item,index) in channelType" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
          <div class="list-R">
            <el-select v-model="data.acceptGroupId" clearable placeholder="请选择接收小组">
              <el-option v-for="(item,index) in groupList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span class="remove" @click="removeRow(dataIndex)">删除</span>
          </div>
        </div>
      </el-form>
    </div>
    <div class="button">
      <el-button v-if="form.type !== 0" type="primary" @click="addRow">添 加</el-button>
      <el-button type="primary" @click="submitForm()">保 存</el-button>
    </div>
  </div>
</template>
<script>
  import {area, province} from '@/models/client/area'
  import Api from '@/api/client/ec-rule'
  export default {
    props: {
      origin: {
        type: String
      }
    },
    data () {
      return {
        area: area,
        province: province,
        typeId: null,
        form: {},
        channelType: [
          {
            id: 1,
            name: '竞价'
          },
          {
            id: 2,
            name: '信息流'
          }
        ],
        typeList: [
          {
            id: 0,
            name: '不限'
          },
          {
            id: 1,
            name: '按资源区域'
          },
          {
            id: 2,
            name: '按渠道类型'
          }
        ],
        choProvince: [],
        acceptGroupId: '',
        groupList: []
      }
    },
    created () {
      this.getList()
      this.getGroupList()
    },
    methods: {
      getList () {
        const crmCode = {
          crmCode: this.origin
        }
        Api.getList(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            // this.typeId = body.type
            this.form = body
            this.setNewList()
          } else {
            this.$message.error(body.error)
          }
        })
      },
      setNewList () {
        const provinceList = []
        for (let i = 0; i < this.form.areaRuleList.length; i++) {
          for (var k in this.form.areaRuleList[i].provinceList) {
            provinceList.push(this.form.areaRuleList[i].provinceList[k])
          }
        }
        this.choProvince = provinceList
        for (var i in this.province) {
          for (var j in this.province[i]) {
            if (this.choProvince.indexOf(this.province[i][j].name) !== -1) {
              this.province[i][j].disable = true
            } else {
              this.province[i][j].disable = false
            }
          }
        }
      },
      getGroupList () {
        Api.getGroupList(response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.groupList = body.list
          } else {
            this.$message.error(body.error)
          }
        })
      },
      choItem (index, value) {
        if (this.choProvince.indexOf(value) !== -1) {
          for (let i = 0; i < this.form.areaRuleList[index].provinceList.length; i++) {
            if (this.form.areaRuleList[index].provinceList[i] === value) {
              this.form.areaRuleList[index].provinceList.splice(i, 1)
            }
          }
          for (let i = 0; i < this.choProvince.length; i++) {
            if (this.choProvince[i] === value) {
              this.choProvince.splice(i, 1)
            }
          }
        } else {
          this.form.areaRuleList[index].provinceList.push(value)
          this.choProvince.push(value)
        }
        this.setNewList()
      },
      removeRow (index) {
        this.$confirm('确定要删除吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.form.type === 1) {
            this.form.areaRuleList.splice(index, 1)
            this.setNewList()
          } else if (this.form.type === 2) {
            this.form.channelTypeRuleList.splice(index, 1)
          }
        }).catch(() => {})
      },
      addRow () {
        if (this.form.type === 1) {
          const form = {
            acceptGroupId: '',
            crmCode: 'ec',
            provinceList: []
          }
          this.form.areaRuleList.push(form)
        } else if (this.form.type === 2) {
          const form = {
            acceptGroupId: '',
            crmCode: 'ec',
            channelType: ''
          }
          this.form.channelTypeRuleList.push(form)
        }
      },
      submitForm (formName) {
        const form = this.form
        Api.saveList({form}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.getList()
            this.$message.success('保存成功！')
          } else {
            this.$message.error(body.error)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .field-setting .el-form-item__label{
    font-size: 14px;
    padding-left:28px;
  }
</style>

<style scoped lang="scss">
.field-setting{
  margin-top:5px;
  h6{
    color:#1F2F3D;
    font-size: 22px;
    font-weight: normal;
    line-height: 3;
    margin:0;
  }
  .button{
    text-align: center;
    margin-top:40px;
  }
  .field-menu{
    border-bottom:1px solid rgba(235,238,245,1);
    padding-bottom:15px;
    span{
      display: inline-block;
      font-size:14px;
      font-weight:bold;
      color:#666;
      &:nth-child(1){
        margin-left:28px;
      }
      &:nth-child(2){
        margin-left:420px;
      }
    }
  }
  .list {
    margin: 0 auto;
    width:100%;
    overflow: hidden;
    border-bottom: 1px solid #F2F4F8;
    padding: 20px 0;
    .list-L{
      width:55%;
      float: left;
      color:#777;
      font-size:14px;
      line-height:25px;
      .area{
        font-weight:bold;
        margin-right:0;
        cursor: inherit;
      }
      span{
        margin-right:5px;
        cursor: pointer;
        &.active{
          color: #085ECC;
        }
        &.no {
          color:#bebebe;
          cursor:no-drop;
        }
      }
    }
    .remove{
      font-size:14px;
      font-weight:500;
      color: #999;
      margin-left:10px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/crm/EcRule.vue